import { Builder } from '@builder.io/react'
import CdnVideo from 'components/util/CdnVideo'
import React from 'react'
import VideoPlayer from '../common/video-player'

interface VideoPlayerProps {
  backgroundColor: string
  videoSrc: any
  cloudinaryVideo: any
  videoShouldLoop: boolean
  playbackSettings: 'string'
  roundedCorners: boolean
  width: number
}

export const EmbedVideo = ({
  videoSrc,
  backgroundColor,
  cloudinaryVideo,
  videoShouldLoop,
  playbackSettings,
  roundedCorners,
  width
}: VideoPlayerProps) => {
  const cloudinaryVideoUrl = cloudinaryVideo?.secure_url?.replace('/upload', '/upload/q_auto')

  return (
    <div className="mx-auto  h-full  w-full" style={{ backgroundColor }}>
      <div
        className={`mx-auto h-full w-full p-5 sm:p-8 lg:h-3/5 lg:w-3/5 ${
          roundedCorners ? 'video-rounded-corners' : ''
        }`}
        style={{ backgroundColor }}
      >
        {videoSrc ? (
          <CdnVideo
            videoSrc={videoSrc}
            videoLoop={videoShouldLoop}
            playbackSettings={playbackSettings}
            width={width}
            account={false}
          />
        ) : (
          <VideoPlayer videoLoop={videoShouldLoop} videoSrc={cloudinaryVideoUrl} playbackSettings={playbackSettings} />
        )}{' '}
      </div>
    </div>
  )
}

Builder.registerComponent(EmbedVideo, {
  name: 'VideoPlayer',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'videoSrc',
      type: 'file',
      defaultValue: null,
      allowedFileTypes: ['mp4']
    },
    {
      name: 'cloudinaryVideo',
      type: 'cloudinaryImageEditor'
    },
    {
      name: 'playbackSettings',
      type: 'string',
      enum: ['Muted with auto play off', 'Muted with auto play on', 'Sound on with auto play off'],
      defaultValue: 'Muted with auto play off'
    },
    {
      name: 'videoShouldLoop',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'roundedCorners',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'width',
      type: 'number'
    }
  ]
})
